import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import OptionsTable, { OptionsTableHandle, OptionsTableProps } from '@/pages/super-admin/settings/ui/OptionsTable'

export type DesmosActData = {
  id: string
  honoraire: string
  id_transposition: string
  libelle: string
}

export type DesmosActsHandle = OptionsTableHandle

export type DesmosActsProps = Omit<OptionsTableProps<DesmosActData>, 'fields' | 'name'>

export const DesmosActs = React.forwardRef(function DesmosActs(props: DesmosActsProps, ref: React.Ref<DesmosActsHandle>) {
  const { t } = useTranslation()

  const fields = useMemo(
    () =>
      [
        {
          id: 'honoraire',
          isMandatory: true,
          name: t('field.honoraire.label'),
          type: 'string',
          placeholder: t('field.honoraire.placeholder', { defaultValue: 'ex: 25.00' }),
          hint: t('field.honoraire.hint', { defaultValue: 'Montant en euros (nombre, ex: 25.00)' }),
        },
        {
          id: 'id_transposition',
          isMandatory: true,
          name: t('field.id_transposition.label'),
          type: 'string',
          placeholder: t('field.id_transposition.placeholder', { defaultValue: 'ex: TCG' }),
          hint: t('field.id_transposition.hint', { defaultValue: 'Act code (alphanumeric, e.g. C, CS, TCG)' }),
        },
        {
          id: 'libelle',
          isMandatory: true,
          name: t('field.libelle.label'),
          type: 'string',
          placeholder: t('field.libelle.placeholder', { defaultValue: 'e.g. General medicine teleconsultation' }),
          hint: t('field.libelle.hint', { defaultValue: 'Label visible to users (free text)' }),
        },
      ] as const,
    [t]
  )

  return <OptionsTable {...props} ref={ref} fields={fields} name="desmosAct" />
})

export default DesmosActs
